import { jsx as _jsx } from "react/jsx-runtime";
import { Controller, useFormContext } from 'react-hook-form';
import { FormControlHtmlEditor, } from './FormControlHtmlEditor';
export function SimpleHtmlEditor({ name, validation, value: fieldValue, onChange: selectOnChange, ...rest }) {
    const { control } = useFormContext();
    return (_jsx(Controller, { control: control, name: name, rules: validation, render: ({ field: { onChange, value }, fieldState: { error } }) => (_jsx(FormControlHtmlEditor, { ...rest, name: name, invalid: !!(error === null || error === void 0 ? void 0 : error.message), error: error === null || error === void 0 ? void 0 : error.message, onChange: value => {
                onChange(value);
                if (typeof selectOnChange === 'function')
                    selectOnChange(value);
            }, value: fieldValue !== null && fieldValue !== void 0 ? fieldValue : value }, void 0)) }, void 0));
}
//# sourceMappingURL=SimpleHtmlEditor.js.map